import PropTypes from 'prop-types';

export default PropTypes.shape({
  documentsView: PropTypes.string,

  study: PropTypes.object,
  studyUrl: PropTypes.string,
});
